import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import VueColumnsResizable from "vue-columns-resizable";
Vue.config.productionTip = false;
Vue.use(VueColumnsResizable);
global.isWT = false;
global.isTest = true;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
